module.exports = __webpack_public_path__ + "static/media/banners_img.fbd8c633.jpg";